import { Button, Image } from 'antd';
import View from '../../components/Base/View';
import './Me.scss';
import Text from '../../components/Base/Text';
import Block from '../../components/Base/Block';
import { useCallback, useEffect, useState } from 'react';
import userUtils from '../../manager/userUtils';
import orderManager from '../../manager/order';
import EventBus from '../../utils/EventBus';
import rm from '../../utils/rm';
import util from '../../utils/util';

function Me() {


  const [userInfo, setUserInfo] = useState<any>({});
  const [hasUserInfo, setHasUserInfo] = useState<boolean>(false);
  const [orderCount, setOrderCount] = useState<{ waitPay: number, waitShip: number, waitConfirm: number }>({
    waitPay: 0,
    waitShip: 0,
    waitConfirm: 0,
  })

  const [getCoinLink, setGetCoinLink] = useState<{ title: string, link: string }>()


  const switchUILoginState = useCallback(() => {

    userUtils.getUserInfoAsync((userInfo) => {
      if (userInfo != null && userInfo.userid > 0) {
        setHasUserInfo(true)
        setUserInfo(userInfo);
        switch (rm.getEnv().app) {
          case "ithome":
            setGetCoinLink({
              title: "赚金币",
              link: "https://img.ithome.com/app/newmy/apppage/user/signin.html?hidemenu=1"
            })
            break;
          case "zuihuimai":
            setGetCoinLink({
              title: "兑换金币",
              link: "https://api.zuihuimai.com/m/user/usercoin?userhash=%7Buserhash%7D"
            })
            break
        }

        orderManager.getOrderCount();
      } else {
        setHasUserInfo(false);
        setUserInfo({})
        setOrderCount({
          waitPay: 0,
          waitShip: 0,
          waitConfirm: 0,
        })
      }
    })

  }, [])

  useEffect(() => {

    const userLoginStateChanged = () => {
      // 获取订单数量
      if (userUtils.isLogin())
        orderManager.getOrderCount();
      switchUILoginState()
    }
    const OrderInfoGet = (info: any) => {
      setOrderCount(info)
    }

    document.title = "我的"

    EventBus.register(EventBus.names.USER_LOGIN_STATE_CHANGE, userLoginStateChanged);
    EventBus.register(EventBus.names.GET_ORDER_COUNT, OrderInfoGet)
    switchUILoginState();
    return () => {
      EventBus.unregister(EventBus.names.USER_LOGIN_STATE_CHANGE, userLoginStateChanged);
      EventBus.unregister(EventBus.names.GET_ORDER_COUNT, OrderInfoGet)
    }
  }, [])

  return (
    <View className='me-container'>
      {/*  用户信息  */}
      {!hasUserInfo ? (
        <Block>
          <View className="userinfo-form" onClick={() => {
            userUtils.doTaskInLoginState(() => {
              switchUILoginState()
            })
          }}>
            <View
              className="btn-clear-style userinfo-login"
            >
              <Image
                preview={false}
                className="userinfo-avatar"
                src={require('../../images/avatar_default.png')}
              ></Image>
              <Text className="userinfo-nickname">点击登录</Text>
            </View>
          </View>
        </Block>
      ) : (
        <Block>
          <View className="userinfo-form" onClick={() => {
            //  util.navigateTo('/pages/account/settings')
            util.navigateTo(`ithome://userpage?id=${userInfo.userid}`)
          }}>
            <View className="btn-clear-style userinfo-login">
              <Image
                preview={false}
                className="userinfo-avatar"
                src={userInfo.avatar || util.getAvatarAddress(userInfo.userid, true)}
              ></Image>
              <View className="user-meta">
                <Text className="userinfo-nickname">{userInfo.nickname}</Text>
                <View className="flex-conainer">
                  {/* 金币 */}
                  <View className="flex-conainer my-coin-num"
                    onClick={(e) => {
                      e.stopPropagation()
                      userUtils.doTaskInLoginState(function (state) {
                        if (state.success) {
                          const url = 'https://m.ithome.com/fund/coindetail?hidemenu=1&needlogin=1&userhash=' + userUtils.getUserHash();
                          util.navigateTo(url);
                        }
                      })
                    }}
                  >
                    <Text>{userInfo.coin + ' 金币'}</Text>
                    <Image
                      preview={false}
                      className="icon-arrow"
                      src={require('../../images/arrow-righr-white.png')}
                    ></Image>
                  </View>
                  {/* 赚金币 */}
                  {!!getCoinLink && <View  className="flex-conainer get-coin-btn"
                  onClick={(e) => {
                    e.stopPropagation()
                    userUtils.doTaskInLoginState(function (state) {
                      if (state.success) {
                        util.navigateTo(getCoinLink.link);
                      }
                    })
                  }}>
                    <Text>{getCoinLink.title}</Text>
                    <Image
                      preview={false}
                      className="icon-arrow"
                      src={require('../../images/right-arrow-grey.png')}
                    ></Image>
                  </View>}
                </View>
              </View>

            </View>
          </View>
        </Block>
      )}
      {/*  订单相关  */}
      <View className="quick-entry">
        <View
          className="quick-entry-item"
          data-state="waitPay"
          onClick={() => {
            userUtils.doTaskInLoginState(function (state) {
              if (state.success) {
                util.navigateTo('/order/myorder?isrmmp=1&hidemenu=1&state=waitPay')
              }
            })
          }}
        >
          <Image
            preview={false}
            className="quick-entry-item-img"
            src={require('../../images/order-wait-pay.png')}
          ></Image>
          {orderCount.waitPay > 0 && (
            <Text className="quick-entry-item-count">
              {orderCount.waitPay}
            </Text>
          )}
          <Text className="quick-entry-item-name">待付款</Text>
        </View>
        <View
          className="quick-entry-item"
          data-state="waitShip"
          onClick={() => {
            userUtils.doTaskInLoginState(function (state) {
              if (state.success) {
                util.navigateTo('/order/myorder?isrmmp=1&hidemenu=1&state=waitShip')
              }
            })
          }}
        >
          <Image
            preview={false}
            className="quick-entry-item-img"
            src={require('../../images/order-wait-send.png')}
          ></Image>
          {orderCount.waitShip > 0 && (
            <Text className="quick-entry-item-count">
              {orderCount.waitShip}
            </Text>
          )}
          <Text className="quick-entry-item-name">待发货</Text>
        </View>
        <View
          className="quick-entry-item"
          data-state="waitConfirm"
          onClick={() => {
            userUtils.doTaskInLoginState(function (state) {
              if (state.success) {
                util.navigateTo('/order/myorder?isrmmp=1&hidemenu=1&state=waitConfirm')
              }
            })

          }}
        >
          <Image
            preview={false}
            className="quick-entry-item-img"
            src={require('../../images/order-wait-receive.png')}
          ></Image>
          {orderCount.waitConfirm > 0 && (
            <Text className="quick-entry-item-count">
              {orderCount.waitConfirm}
            </Text>
          )}
          <Text className="quick-entry-item-name">待收货</Text>
        </View>
        <View
          className="quick-entry-item"
          data-state="confirmed"
          onClick={() => {
            userUtils.doTaskInLoginState(function (state) {
              if (state.success) {
                util.navigateTo('/order/myorder?isrmmp=1&hidemenu=1&state=confirmed')
              }
            })

          }}
        >
          <Image
            preview={false}
            className="quick-entry-item-img"
            src={require('../../images/order-confirmed.png')}
          ></Image>
          <Text className="quick-entry-item-name">已完成</Text>
        </View>
        <View className="quick-entry-item" onClick={() => {
          userUtils.doTaskInLoginState(function (state) {
            if (state.success) {
              util.navigateTo('/aftersale/list?isrmmp=1&hidemenu=1')
            }
          })
        }}>
          <Image
            preview={false}
            className="quick-entry-item-img"
            src={require('../../images/order-all.png')}
          ></Image>
          <Text className="quick-entry-item-name">售后服务</Text>
        </View>
        <View className="float-fix"></View>
      </View>
      {/*  推荐给好友  */}
      <View>
        <View
          className="user-list-btn btn-clear-style"
          onClick={() => {
            userUtils.doTaskInLoginState(function (state) {
              if (state.success) {
                util.navigateTo('/myassets/mycoupon?isrmmp=1&hidemenu=1')
              }
            })
          }}
        >
          <Text className="setting-name">我的优惠券</Text>
          <Image
            preview={false}
            className="user-list-btn-icon"
            src={require('../../images/right-arrow.png')}
          ></Image>
        </View>
        <View
          className="user-list-btn btn-clear-style"
          onClick={() => {
            userUtils.doTaskInLoginState(function (state) {
              if (state.success) {
                util.navigateTo('/myassets/myfav?isrmmp=1&hidemenu=1')
              }
            })
          }}
        >
          <Text className="setting-name">我的收藏</Text>
          <Image
            preview={false}
            className="user-list-btn-icon"
            src={require('../../images/right-arrow.png')}
          ></Image>
        </View>
        <View
          className="user-list-btn btn-clear-style"
          onClick={() => {
            userUtils.doTaskInLoginState(function (state) {
              if (state.success) {
                util.navigateTo('/address/list?isrmmp=1&hidemenu=1')
              }
            })
          }}
        >
          <Text className="setting-name">收货地址</Text>
          <Image
            preview={false}
            className="user-list-btn-icon"
            src={require('../../images/right-arrow.png')}
          ></Image>
        </View>
        {(
          <View
            className="user-list-btn btn-clear-style"
            onClick={() => {
              userUtils.doTaskInLoginState(function (state) {
                if (state.success) {
                  util.navigateTo(`https://m.ithome.com/fund/my?userhash=${userUtils.getUserHash()}&hidemenu=1&night=0&amoled=0`)
                }
              })

            }}
          >
            <Text className="setting-name">我的资产</Text>
            <Image
              preview={false}
              className="user-list-btn-icon"
              src={require('../../images/right-arrow.png')}
            ></Image>
          </View>
        )}
        {/* <Button
            className="user-list-btn btn-clear-style"
            openType="contact"
            sessionFrom="设置"
          >
            <Text className="setting-name">联系客服</Text>
            <Image
              className="user-list-btn-icon"
              src={require('../../images/right-arrow.png')}
            ></Image>
          </Button> */}
        {/* <Picshare
            className="shareDialog"
            sharePicUrl="https://img.lapin365.com/weixin/images/share_poster.png"
            onLongtap={this.copySchemeUrl}
          >
            <Button className="user-list-btn btn-clear-style share-btn">
              <Text className="setting-name">分享给好友</Text>
              <Image
                className="user-list-btn-icon"
                src={require('../../images/right-arrow.png')}
              ></Image>
            </Button>
          </Picshare> */}
        {/* <Button
            className="user-list-btn btn-clear-style feedback-btn"
            openType="feedback"
          >
            <Text className="setting-name">产品反馈</Text>
            <Text className="setting-style-des">
              {'v' + appVersion + (isDebug ? 'Beta' : '')}
            </Text>
            <Image
              className="user-list-btn-icon"
              src={require('../../images/right-arrow.png')}
            ></Image>
          </Button> */}
        {/* <Navigator
            className="user-list-btn btn-clear-style mall-btn"
            target="miniProgram"
            appId="wx8869812e2ddf7133"
            path="pages/index/index"
          >
            <Text className="setting-name">IT之家小程序</Text>
            <Image
              className="user-list-btn-icon"
              src={require('../../images/right-arrow.png')}
            ></Image>
          </Navigator> */}
        <Button
          className="user-list-btn btn-clear-style"
          style={{
            display: 'none',
          }}
        >
          <Text className="setting-name">设置</Text>
          <Image
            preview={false}
            className="user-list-btn-icon"
            src={require('../../images/right-arrow.png')}
          ></Image>
        </Button>
      </View>
    </View>
  );
}

export default Me;
